import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';

const useBattleGamePopupTStyles = createUseStyles((theme: Theme) => {
    return {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.82)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10000,
            padding: theme.spacing(2),
            boxSizing: 'border-box' as const,
        },
        popup: {
            backgroundColor: '#4a3824',
            border: '2px dotted #e9d4a8',
            borderRadius: '4px',
            padding: '2rem',
            width: '100%',
            maxWidth: '480px',
            boxSizing: 'border-box' as const,
            display: 'flex',
            flexDirection: 'column' as const,
            alignItems: 'center',
            gap: theme.spacing(3),
        },
        felicitari: {
            fontFamily: theme.fonts.poplar,
            color: '#e9d4a8',
            fontSize: '2rem',
            fontWeight: 'bold',
            textAlign: 'center',
            [theme.breakpoints.up('md')]: {
                fontSize: '2.5rem',
            },
        },
        description: {
            fontFamily: theme.fonts.apex,
            color: '#e9d4a8',
            fontSize: '0.92rem',
            textAlign: 'center',
            lineHeight: 1.6,
        },
        scoreBadge: {
            backgroundColor: '#4a7c3f',
            color: '#e9d4a8',
            fontFamily: theme.fonts.poplar,
            fontSize: '1.6rem',
            fontWeight: 'bold',
            padding: `${theme.spacing(1)} ${theme.spacing(5)}`,
            borderRadius: '6px',
            border: '3px solid #6aab5e',
            letterSpacing: '1px',
            display: 'inline-block',
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
        },
        closeButton: {
            backgroundColor: '#f5e8c9',
            color: '#4a3824',
            fontFamily: theme.fonts.apex,
            fontWeight: 'bold',
            fontSize: '1rem',
            padding: `${theme.spacing(1.5)} ${theme.spacing(4)}`,
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            textTransform: 'uppercase' as const,
            letterSpacing: '1px',
            transition: 'background-color 0.2s ease',
            '&:hover': {
                backgroundColor: '#ffffff',
            },
        },
    };
});

export default useBattleGamePopupTStyles;
